module.exports = __webpack_public_path__ + "img/Small_ferm.ab118398.png";